import React, { FC, useEffect } from "react";
import { YHModal } from "@/components/YHModal";
import { useCardModel } from "../cardModel";
import { YHPhone } from "@/components/YhPhone";
import "./weChart.css";
import phoneIcon from "../../../assets/phone-icon.png";
import emailIcon from "../../../assets/email-icon.png";
import addressIcon from "../../../assets/address-icon.png";
import siteIcon from "../../../assets/site-icon.png";
import triangle from "../../../assets/triangle.png";
import qrCode from "../../../assets/qr-code-icon.png";
import share from "../../../assets/share.png";
import business from "../../../assets/business.png";
import company from "../../../assets/company.png";
import barBg from "../../../assets/bar-bg.jpg";

export const WeChartModal = () => {
    const { reviewVisible: { visible, rowDetail }, setReviewVisible } = useCardModel(({ reviewVisible }) => [reviewVisible])
    const { ebcBusinessDto, ebcCompanyDto } = rowDetail;

    useEffect(() => {
        if (visible) {
        }
    }, [visible])

    const onCancel = () => {
        setReviewVisible({ visible: false, rowDetail: {} });
    };

    return <YHModal
        visible={visible}
        okText="确认"
        onOk={() => { }}
        onCancel={onCancel}
        title="名片预览"
        width={600}
        bodyHeight={900}
    >
        <div style={{ color: "#f00", textAlign: "center" }}>*仅供参考，如有出入以小程序展示为准</div>
        <YHPhone title="我的名片">
            <div className="phone-wrap">
                <div className="card-container">
                    {rowDetail.style === "A" ?
                        <>
                            <div className="card-logoA">
                                <img src={`https://fserv-pub2-1301309125.cos.ap-beijing.myqcloud.com/${rowDetail.ebcCompanyDto?.logo}`} className="logo-img" />
                            </div>
                            <div className="card-avatarA">
                                <img src={`https://fserv-pub2-1301309125.cos.ap-beijing.myqcloud.com/${rowDetail.icon}`} className="avatar-img" />
                            </div>
                            <div className="card-infoA">
                                <div className="name">{rowDetail.isNameEn === "1" ? rowDetail.nameEn || "" : rowDetail.name || ""}</div>
                                <div className="company">{rowDetail.company || ""}</div>
                                <div className="position">
                                    <span>{rowDetail.depName || ""}</span>
                                    {rowDetail.depName && rowDetail.position && <span className="septal">/</span>}
                                    <span>{rowDetail.position || ""}</span>
                                </div>
                            </div>
                            <div className="card-bottomA">
                                <div className="card-item">
                                    <img src={phoneIcon} alt="" />
                                    <span className="content">{rowDetail.phone || ""}</span>
                                </div>
                                <div className="card-item">
                                    <img src={emailIcon} alt="" />
                                    <span className="content">{rowDetail.email || ""}</span>
                                </div>
                                <div className="card-item">
                                    <img src={siteIcon} alt="" />
                                    <span className="content">{rowDetail.website || ""}</span>
                                </div>
                                <div className="card-item">
                                    <img src={addressIcon} alt="" />
                                    <span className="content">{rowDetail.address || ""}</span>
                                </div>
                            </div>
                        </> :
                        <>
                            <div className="card-top dflex">
                                <div className="card-avatarB">
                                    <img src={`https://fserv-pub2-1301309125.cos.ap-beijing.myqcloud.com/${rowDetail.icon}`} className="avatar-img" />
                                    <div className="name">{rowDetail.isNameEn === "1" ? rowDetail.nameEn || "" : rowDetail.name || ""}</div>
                                    <div className="position">
                                        <span>{rowDetail.depName || ""}</span>
                                        {rowDetail.depName && rowDetail.position && <span className="septal">/</span>}
                                        <span>{rowDetail.position || ""}</span>
                                    </div>
                                </div>
                                <div className="card-logoB">
                                    <div className="logo-wrap">
                                        <img src={`https://fserv-pub2-1301309125.cos.ap-beijing.myqcloud.com/${rowDetail.ebcCompanyDto?.logo}`} className="logo-img" />
                                        <div className="company">{rowDetail.company || ""}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-bottomB">
                                <div className="card-item">
                                    <img src={phoneIcon} alt="" />
                                    <span className="content">{rowDetail.phone || ""}</span>
                                </div>
                                <div className="card-item">
                                    <img src={emailIcon} alt="" />
                                    <span className="content">{rowDetail.email || ""}</span>
                                </div>
                                 <div className="card-item">
                                    <img src={siteIcon} alt="" />
                                    <span className="content">{rowDetail.website || ""}</span>
                                </div>
                                <div className="card-item">
                                    <img src={addressIcon} alt="" />
                                    <span className="content">{rowDetail.address || ""}</span>
                                </div>
                            </div>
                        </>}
                    <div className="card-qr">
                        <img src={triangle} className="triangle" />
                        <img src={qrCode} className="qr" />
                    </div>
                </div>

            </div>
            <div className="home-share">
                <div className="dots-warp dflex">
                    <span className="active"></span>
                </div>
                <div className="but-warp dflex">
                    <div className="but-item share-but dflex">
                        <img src={share}></img>
                        <span>分享名片</span>
                    </div>
                </div>
            </div>


            <div className="page-bottom">
                <div className="introduce-wrap">
                    <img src={company} />
                    <div className="info">
                        <span className="title">{ebcCompanyDto?.name}</span>
                        <span className="content">{ebcCompanyDto?.profiles}</span>
                    </div>
                    <div className="mark">公司介绍</div>
                </div>
                <div className="introduce-wrap">
                    <img src={business} />
                    <div className="info">
                        <span className="title">{ebcBusinessDto?.name}</span>
                        <span className="content">{ebcBusinessDto?.profiles}</span>
                    </div>
                    <div className="mark">业务介绍</div>
                </div>
            </div>


            <div className="bottom-tab">
                <img src={barBg} alt="" />
            </div>
        </YHPhone>
    </YHModal>
}